import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  useCreateInputPrice,
  useCreateOutputPrice,
  useGetInputPriceById,
  useGetOutputPriceById,
  useGetWarehouseById,
  useUpdateInputPrice,
  useUpdateOutputPrice,
  useWarehouseList,
} from "../../api/admin";
import {
  useCreateFarmingStage,
  useUpdateFarmingStage,
  useGetFarmingStageById,
} from "../../api/farming_stage";
import { useProductList } from "../../api/product";
import create from "@ant-design/icons/lib/components/IconFont";
import { useInputList } from "../../api/input";
import dayjs from "dayjs";

type InputPriceModalProps = {
  open: boolean;
  selectedId?: number;
  hideModal: () => void;
};

const InputPriceModal: React.FC<InputPriceModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const [inputPrice, setInputPrice] = useState<number>();
  const [effectiveDate, setEffectiveDate] = useState<string>();
  const [selectedInputId, setSelectedInputId] = useState<number>();
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>();
  const [status, setStatus] = useState<number>();

  const { data: selectedInputPrice, refetch } =
    useGetInputPriceById(selectedId);
  const { data: inputs, isLoading: inputsLoading } = useInputList();
  const { mutateAsync: createOutputPrice, isPending: creating } =
    useCreateInputPrice();
  const { mutateAsync: updateInputPrice, isPending: updating } =
    useUpdateInputPrice();

  const { data: warehouses } = useWarehouseList();

  useEffect(() => {
    if (selectedId) {
      refetch();
    } else {
      resetForm();
    }
  }, [selectedId]);

  useEffect(() => {
    if (
      selectedInputPrice &&
      selectedInputPrice.data &&
      selectedInputPrice.data.data
    ) {
      console.log(selectedInputPrice);
      setSelectedInputId(selectedInputPrice.data.data.input.id);
      setInputPrice(selectedInputPrice.data.data.inputPrice);
      setEffectiveDate(selectedInputPrice.data.data.effectiveDate);
      setSelectedWarehouseId(selectedInputPrice.data.data.warehouse.id);
      setStatus(selectedInputPrice.data.data.status);
    }
  }, [selectedInputPrice]);

  const onsubmit = async () => {
    if (effectiveDate) {
      const year = Number(effectiveDate.split("/")[2]);
      const month = Number(effectiveDate.split("/")[0]);
      const date = Number(effectiveDate.split("/")[1]);
      if (selectedId === undefined) {
        try {
          const _input = inputs?.data?.data?.find(
            (item: any) => item.id === selectedInputId
          );
          const _center = warehouses?.data?.data?.find(
            (item: any) => item.id === selectedWarehouseId
          );

          if (_input && _center && effectiveDate && inputPrice) {
            const data = {
              id: null,
              input: _input,
              warehouse: _center,
              inputPrice,
              effectiveDate: new Date(year, month, date).getTime(),
              status: null,
              agroDealer: null,
            };

            const result = await createOutputPrice(data);

            if (result && result.status === 200) {
              message.success("Price created successfully");
            }
          }
        } catch (err: any) {
          message.error("Operation failed");
        } finally {
          hideModal();
        }
      } else {
        try {
          const _input = inputs?.data?.data?.find(
            (item: any) => item.id === selectedInputId
          );
          const _center = warehouses?.data?.data?.find(
            (item: any) => item.id === selectedWarehouseId
          );

          const data = {
            id: selectedId,
            input: _input,
            warehouse: _center,
            inputPrice,
            effectiveDate: new Date(year, month, date).getTime(),
            status,
          };
          const result = await updateInputPrice(data);

          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.id
          ) {
            message.success("Price updated successfully");
          }
        } catch (err: any) {
          message.error("Operation failed");
        } finally {
          hideModal();
        }
      }
    }
  };

  const resetForm = () => {};

  return (
    <Modal
      afterClose={resetForm}
      destroyOnClose={true}
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId !== undefined ? "Edit Input Price" : "Create Input Price"}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      // okText={isPending ? 'Saving...' : 'Ok'}
      okButtonProps={{
        disabled: creating || updating,
        loading: creating || updating,
      }}
      onCancel={hideModal}
      closable
    >
      <div className="flex flex-col gap-4">
        <Select
          value={selectedInputId}
          placeholder="Select product"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedInputId(Number(val))}
          options={inputs?.data?.data?.map((item: any) => {
            return { label: item.name, value: item.id };
          })}
        />
        <Select
          value={selectedWarehouseId}
          placeholder="Select Center"
          style={{ width: "100%" }}
          onChange={(val: any) => setSelectedWarehouseId(Number(val))}
          options={warehouses?.data?.data?.map((item: any) => {
            return { label: item.centerName, value: item.id };
          })}
        />
        <DatePicker
          // value={dayjs(effectiveDate)}
          onChange={(_, dateString) => {
            console.log(dateString);
            const _date = new Date(dateString as string);
            setEffectiveDate(
              `${_date.getMonth()}/${_date.getDate()}/${_date.getFullYear()}`
            );
          }}
        />
        <InputNumber
          className="w-full"
          placeholder="Insert input price"
          value={inputPrice}
          onChange={(e) => setInputPrice(e ?? 0)}
        />
        {selectedId && (
          <Select
            value={status}
            placeholder="Select Center"
            style={{ width: "100%" }}
            onChange={(val: any) => setStatus(val)}
            options={[
              { label: "ACTIVE", id: "1" },
              { label: "INACTIVE", id: "0" },
            ].map((item: { label: string; id: string }) => {
              return { label: item.label, value: item.id };
            })}
          />
        )}
      </div>
    </Modal>
  );
};

export default InputPriceModal;
